import { writable } from 'svelte/store';
export const optionalTaxes = writable({});
export const assessedValue = writable(0);
export const nonAssessedValueTaxAmounts = writable({});